import {
  E164_REGEX,
  WEBSITE_CANVAS_STORE_NAME_MAX_LENGTH,
  buildImageProxyUrl,
  checkMerchantText,
  type Store,
  type WebsiteCanvasStoreIdentity,
} from '@dukanti/shared';

type StoreIdentitySource = Pick<
  Store,
  'slug' | 'name' | 'logo_storage_path' | 'whatsapp_number' | 'phone_number'
>;

function isSafeLocalOrHttps(url: URL): boolean {
  return (
    url.protocol === 'https:' ||
    (url.protocol === 'http:' && (url.hostname === 'localhost' || url.hostname === '127.0.0.1'))
  );
}

function phoneOrNull(value: string | null): string | null {
  return value !== null && E164_REGEX.test(value) ? value : null;
}

/**
 * The public identity the canvas needs for the template header and footer: a
 * store being set up is not public yet, so the canvas cannot read it itself.
 * Every field is what the canvas parser accepts; anything it would refuse is
 * dropped here, because one refused field would refuse the whole page.
 */
export function toCanvasStoreIdentity(
  store: StoreIdentitySource,
  supabaseUrl: string,
): WebsiteCanvasStoreIdentity {
  const named = checkMerchantText(store.name, { maxLength: WEBSITE_CANVAS_STORE_NAME_MAX_LENGTH });

  let logoUrl: string | null = null;
  if (store.logo_storage_path) {
    try {
      const url = new URL(buildImageProxyUrl(supabaseUrl, 'store-logos', store.logo_storage_path));
      if (isSafeLocalOrHttps(url) && !url.username && !url.password && url.href.length <= 1024) {
        logoUrl = url.toString();
      }
    } catch {
      logoUrl = null;
    }
  }

  return {
    name: named.ok ? store.name : store.slug,
    logoUrl,
    whatsappNumber: phoneOrNull(store.whatsapp_number),
    phoneNumber: phoneOrNull(store.phone_number),
  };
}
